<script>
import { addByShipxy } from '@/api/ship/shipInstance'
export default {
  components: {},
  data() {
    return {
      show: false,
      form: {
        name: null,
        shipownerName: null,
        shipownerContact: null,
      },
      rules: {
        name: [
          { required: true, message: '请输入船名', trigger: 'blur' },
        ],
        shipownerName: [
          { required: true, message: '请输入船老大', trigger: 'blur' },
        ],
        shipownerContact: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
        ],
      },

      submitDisabled: false,
      formLoading: false,
    };
  },
  computed: {
    
  },
  watch: {},
  mounted() {

  },
  methods: {
    open(row) {
      Object.assign(this.$data, this.$options.data())
      this.show = true
      Object.assign(this.form, row)
    },
    onDialogOpen() {
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    onClose() {
      this.$emit('close')
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        this.submitDisabled = true
        this.formLoading = true
        addByShipxy(this.form).then(res => {
          this.submitDisabled = false
          this.formLoading = false
          this.$emit('complete', res.data || this.form)
        }).catch(() => {
          this.submitDisabled = false
          this.formLoading = false
        })
      })
    }
  }
}
</script>

<template>
  <el-dialog
    title="维护船舶"
    :visible.sync="show"
    :close-on-click-modal="false"
    width="600px"
    @open="onDialogOpen"
    @close="onClose"
    append-to-body
  >
    <el-alert
      title="该船舶未在数据库中，请先进行维护"
      type="warning"
      show-icon>
    </el-alert>
    <el-form ref="form" :model="form" :rules="rules" label-position="top" label-width="80px">
      <el-form-item label="船名" prop="name">
        <el-input v-model="form.name" placeholder="请输入" maxlength="30" />
      </el-form-item>
      <div class="grid grid-cols-2 gap">
        <el-form-item label="船老大" prop="shipownerName">
          <el-input v-model="form.shipownerName" placeholder="请输入" maxlength="20" />
        </el-form-item>
        <el-form-item label="联系方式" prop="shipownerContact">
          <el-input v-model="form.shipownerContact" placeholder="请输入" maxlength="30" />
        </el-form-item>
      </div>
    </el-form>

    <div slot="footer">
      <el-button @click="show = false">{{ $t('general.form.cancel') }}</el-button>
      <el-button :disabled="submitDisabled" :loading="formLoading" type="primary" class="eu-submit-btn" @click="onSubmit">确认维护</el-button>
    </div>
  </el-dialog>
</template>

<style lang="scss" scoped>

</style>
